import pollReducers from './poll-slice';

export default {
  ...pollReducers,
};

export {default as saga} from './poll-sagas';

export * from './poll-slice';
